import React, { FC } from 'react'
import styles from './Event.module.css'
import { ImageType } from '../../pages/MainPage/MainPage'
import personCountIcon from '../../assets/icons/event-user.svg'
import { Slide } from 'react-slideshow-image'
import './Event.css'
import { useNavigate } from 'react-router-dom'
import PATH from '../../navigation/path'
import arrowPrev from '../../assets/icons/arrowLeft.svg'
import arrowNext from '../../assets/icons/arrowRight.svg'
import noImage from '../../assets/img/no-image.jpg'
import { useAppSelector } from '../../redux/types/types'

export type EventPropsType = {
  fromMainPage?: boolean
  id: number
  images: ImageType[]
  title: string
  subTitle: string
  numberOfPerson: string
  forEstablishments?: boolean
  bookingData?: {
    city: string
    startDate: string
    finishDate: string
    startTime: string
    finishTime: string
    guestsNumber: string
    titlePage: string
  } | null
}

const Event: FC<EventPropsType> = ({
  fromMainPage,
  id,
  images,
  title,
  subTitle,
  numberOfPerson,
  bookingData,
  forEstablishments,
}) => {
  const navigate = useNavigate()
  const { userRole } = useAppSelector((state) => state.auth)
  const onActiveCurrentEvent = (e: React.MouseEvent) => {
    if (forEstablishments) {
      navigate(`${PATH.establishmentCardPage}${id}`, {
        state: { bookingData, fromMainPage },
      })
    } else {
      navigate(`${PATH.platformCardPage}${id}`, {
        state: { bookingData, fromMainPage },
      })
    }
  }

  const handleArrowClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const properties = {
    canSwipe: false,
    duration: 5000,
    autoplay: false,
    transitionDuration: 500,
    arrows: false,
    infinite: true,
    easing: 'ease',
    indicators: () => <div className='sliderIndicator'></div>,
    prevArrow: (
      <div className={styles.arrowPrevBlock} onClick={handleArrowClick}>
        <img className={styles.arrowPrev} src={arrowPrev} alt='arrowPrev' />
      </div>
    ),
    nextArrow: (
      <div className={styles.arrowNextBlock} onClick={handleArrowClick}>
        <img className={styles.arrowNext} src={arrowNext} alt='arrowNext' />
      </div>
    ),
  }

  

  return (
    <div onClick={(e) => onActiveCurrentEvent(e)} className={styles.event}>
      <div className={styles.slider}>
        {images.length !== 0 ? (
          <Slide {...properties} cssClass='sliderContainer'>
            {images.map((slideImage, index) => {
              return (
                <div
                  onClick={(e) => onActiveCurrentEvent(e)}
                  key={index}
                  className={styles.slideImage}
                  style={{ backgroundImage: `url("${slideImage.src}")`, zIndex: 0 }}
                ></div>
              )
            })}
          </Slide>
        ) : (
          <div className={styles.slideImage}>
            <img className={styles.slideImage} src={noImage} alt='noImage' />
          </div>
        )}
      </div>
      <div className={styles.eventDescriptionBlock}>
        <h2 className={styles.title}>{title}</h2>
        {(userRole === 'superAdmin' || userRole === 'admin') && (
          <h3 className={styles.subTitle}>{subTitle}</h3>
        )}
        {!forEstablishments && (
          <div className={styles.personCount}>
            <img className={styles.personCountIcon} src={personCountIcon} alt='personCountIcon' />
            <p className={styles.personCountText}>{`до ${numberOfPerson} человек`}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Event
